var _style, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonarchLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 499 117.3",
    style: {
      enableBackground: "new 0 0 499 117.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29B4CC;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#45447F;}\n\t.st3{fill:#F05A34;}\n\t.st4{fill:url(#SVGID_00000051353335862787426180000011605846040171966651_);}\n\t.st5{fill:url(#SVGID_00000079465999436282639820000000080924148184664480_);}\n\t.st6{enable-background:new    ;}\n\t.st7{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000164508641945804492010000015144627164577180842_"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,0c17.2,13.6,19.6,50.2,11.3,61.9s-30.9,33-50.6,29.7s-8.6-67.6-2.3-59C66.7,20.2,80.6,9.3,103,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1429.6345,
    y1: -11.4904,
    x2: -1429.1545,
    y2: -10.6304,
    gradientTransform: "matrix(34.9459 25.278 -35.7515 49.425 49642.6445 36736.0703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#73BCD1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.6,88.3c11.5-4.1,19.8-13.2,24.9-27.6c4.1-12.7,2.3-25.2-9.4-36.4c-13.5,2.1-22.9,8.8-28.2,20.3 C77.2,59.5,81.4,74.2,81.6,88.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,103.2C56.8,87.3,75,78.8,80.1,77.6c7.6-1.7,12.4-1.5,13.4,0c1,1.5,1.3,2.6,1.3,2.6 c0.4,2.5-1.4,5.4-3.9,6.4C44.6,104.7,29,110.7,29,110.7c-3,1.2-6.5,1.2-8,0.2l0,0C18.6,109.2,20.6,105.7,25.5,103.2L25.5,103.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.5,0c21.9,0.7,43.3,24.3,45,43c1.7,18.7-6.6,47-23.5,55c-16.9,8-40.7,12-54.5,5c-13.7-7-15.8-22.2-8-36 s16.8-19.2,27-16C28.4,37.8,33.1,20.9,45.5,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067205682926039362310000004632484735634157704_",
    gradientUnits: "userSpaceOnUse",
    x1: -1412.5317,
    y1: -17.8258,
    x2: -1412.1317,
    y2: -17.0158,
    gradientTransform: "matrix(43.13 0 0 61 60980.6328 1124.0195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#FAB155"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067205682926039362310000004632484735634157704_)"
    },
    d: "M79.2,83.8c6.9-10,8.3-22.3,4-37 c-4.2-12.7-12.9-21.8-29-24c-9.7,9.6-13.4,20.6-11,33C58.8,63.1,70.8,72.5,79.2,83.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005959997114212150610000005538250355105081996_",
    gradientUnits: "userSpaceOnUse",
    x1: -1410.9353,
    y1: -28.917,
    x2: -1410.2653,
    y2: -28.737,
    gradientTransform: "matrix(62.1 0 0 40.01 87656.7188 1239.2607)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#FAB55D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005959997114212150610000005538250355105081996_)"
    },
    d: "M77.7,85.3c-4.8,9.2-18,16.8-42,17 c-13.4-0.5-21.1-6.5-20-18c0.8-8.4,8.1-21.5,24-22S77.8,83.7,77.7,85.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M194.1,49.4c10.1,0,15.3,6.2,15.3,18.5v25.9h-5.3V68.7c0-11.2-4.2-14.3-11-14.3c-7.4,0-14.2,7.2-14.2,14.8 v24.6h-5.3V68.7c0-11.2-4.2-14.3-11-14.3c-7.4,0-14.2,7.2-14.2,14.8v24.6h-5.3V50.6h4.6l0.4,8.4c2.7-5.4,8.3-9.6,15.5-9.6 c8.3,0,12.4,4.1,14.3,10.2C181.4,53.4,186.9,49.4,194.1,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.7,49.2c13.2,0,22.6,10.4,22.6,23s-9.4,23-22.6,23c-13.2,0-22.6-10.4-22.6-23S225.5,49.2,238.7,49.2z  M238.7,54c-9.8,0-17.3,7.6-17.3,18.2s7.5,18.2,17.3,18.2c9.8,0,17.3-7.6,17.3-18.2S248.5,54,238.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M300.8,93.8V69.2c0-11.2-4.6-14.8-11.9-14.8c-7.9,0-15.5,7.2-15.5,14.8v24.6h-5.3V50.6h4.6l0.4,8.7 c3-5.7,9.8-9.9,17-9.9c10.6,0,16,6.7,16,19v25.4H300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M334.8,49.4c6.3,0,14.2,3.2,17.5,10.1l0.2-8.9h4.6v43.2h-4.6l-0.2-8.9C349,91.8,341.1,95,334.8,95 c-12.5,0-21.5-9.7-21.5-22.8S322.3,49.4,334.8,49.4z M335.4,90.3c9.2,0,16.8-6.7,16.8-18.1c0-11.4-7.6-18.1-16.8-18.1 c-9.2,0-16.8,6.7-16.8,18.1C318.6,83.6,326.2,90.3,335.4,90.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M368.9,51l4.4-0.9l0.6,8.8c3.1-4.9,10-9.5,16.6-9.5v6.2c-7.9-1.2-16.3,4.8-16.3,12.4v25.8h-5.3V51z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M414.3,49.4c5.3,0,9.9,1,14.4,4.1v5.1c-4-3-9.2-4.5-13.7-4.5c-10,0-17.1,7.4-17.1,18.1 c0,10.7,7.1,18.1,17.1,18.1c4.5,0,9.7-1.5,13.7-4.5v5.1c-4.4,3.1-9.1,4.1-14.4,4.1c-12.4,0-21.7-9.4-21.7-22.8 C392.6,58.8,401.9,49.4,414.3,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M457.9,49.4c10.6,0,16,6.7,16,19v25.4h-5.3V69.2c0-11.2-4.6-14.8-11.9-14.8c-7.9,0-15.5,7.2-15.5,14.8v24.6 h-5.3v-60h5.3v25.1C444.3,53.4,450.9,49.4,457.9,49.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonarchLogo);
export default __webpack_public_path__ + "static/media/monarch-logo.ec258e3683177fc5493202f1de0fb98e.svg";
export { ForwardRef as ReactComponent };